import Model from 'src/models/Model'
export default class CheckoutData extends Model {
  static name = 'CheckoutData'

  static define () {
    this.fields = {
      showLoading: {
        type: Boolean,
        default: false
      },

      stepTitle: {
        type: String,
        default: ''
      },
      purchasingMembership: {
        type: Boolean,
        default: false
      },

      showMovieCard: {
        type: Boolean,
        default: false
      },
      showActivityCard: {
        type: Boolean,
        default: false
      },
      showCartControls: {
        type: Boolean,
        default: false
      },
      showCheckoutFooter: {
        type: Boolean,
        default: false
      },
      hasRedemptions: {
        type: Boolean,
        default: false
      },

      expandDefault: {
        type: Boolean,
        default: false
      },
      expandTickets: {
        type: Boolean,
        default: false
      },
      expandConcessions: {
        type: Boolean,
        default: false
      },
      expandCartDrawer: {
        type: Boolean,
        default: false
      },

      infoTitle: {
        type: String,
        default: 'Info'
      },
      info: {
        type: String,
        default: null
      },
      selectedSeats: {
        type: String,
        default: null
      },
      showInfo: {
        type: Boolean,
        default: true
      },
      showSubtotal: {
        type: Boolean,
        default: true
      },
      showTotals: {
        type: Boolean,
        default: true
      },
      nextButtonLabel: {
        type: String,
        default: 'Next'
      },
      showEmptyCartNextLabel: {
        type: Boolean,
        default: false
      },
      nextPage: {
        type: String,
        default: '#'
      },
      sessionData: {
        type: Object,
        default: () => ({})
      },
      canProceed: {
        type: Boolean,
        default: false,
        computed () {
          return this.configuration.currentSite.consumerConfig.showTicketFirstCheckoutFlow
            ? this.data.canProceed
            : (_(this.sessionData).entries().every(([_showingId, showingData]) => {
                return !showingData.hasSeatChartError && !showingData.hasTicketSelectionError
              })) && this.data.canProceed
        }
      },
      unableToProceedNextButtonLabel: {
        type: String,
        default: null
      },
      guestCheckoutConfirmed: {
        type: Boolean,
        default: false
      },
      hasUserAcknowledgedTicketPrintingDisabled: {
        type: Boolean,
        default: false
      },
      trackingData: {
        type: Object,
        default: {}
      },
      showtimeChangeCount: {
        type: Number,
        default: 0
      },
      removeSeats: {
        type: Array,
        default: () => []
      },
      headerHeight: {
        type: Number,
        default: 100
      }
    }
  }

  selectedSeatsForShowingId (showingId) {
    if (_.isNil(showingId) || showingId === '') return []

    return this.sessionData[showingId.toString()]?.selectedSeats || []
  }
}

export function isTicketSelectionComplete (order, showingId, selectedSeats) {
  return !_.isEmpty(selectedSeats) &&
      _.isEmpty(unassignedSelectedSeats(order, showingId, selectedSeats)) &&
      _(order.draftShowingTicketOrderItems(showingId))
        .filter(orderItem => !orderItem.ticket.seatName)
        .isEmpty()
}

export function unassignedSelectedSeats (order, showingId, selectedSeats) {
  const selectedSeatNamesAssignedToTickets = order.draftSelectedSeats(showingId)
  return _.filter(selectedSeats, seat => !_.includes(selectedSeatNamesAssignedToTickets, seat.name))
}

export function getSeatNameForTicketType (order, showingId, ticketType, selectedSeats) {
  return _.find(unassignedSelectedSeats(order, showingId, selectedSeats), seat => !seat.limitTicketTypes || _.includes(seat.ticketTypeIds, ticketType.id))?.name
}

export function canSelectTicketTypeOrPackage (order, showing, ticketTypeOrPackage, selectedSeats, ticketFirstCheckoutFlow = false) {
  if (!showing.reservedSeating || ticketFirstCheckoutFlow) {
    // TODO: The concept of "selectable" vs "available" is confusing and seems to be treated different depending
    // on whether the reserved seating is enabled or not. For now, in the case of non-reserved seating, other
    // component methods handle checking whether this ticket type or package has availability
    return true
  } else if (ticketTypeOrPackage.typeName === 'ItemPackage') {
    const seatsToAssign = unassignedSelectedSeats(order, showing.id, selectedSeats)

    if (_.isEmpty(seatsToAssign)) return false

    const itemPackageTicketTypesGroupedByTicketTypeId = _(ticketTypeOrPackage.itemPackageItems.data).map('ticketType').compact().groupBy('id').value()
    return _(itemPackageTicketTypesGroupedByTicketTypeId)
      .entries()
      .every(([ticketTypeId, ticketTypes]) => {
        const numSeatsRequiredForTicketType = ticketTypes.length
        const numSeatsAvailableForTicketType = _.filter(seatsToAssign, seat => {
          const ticketType = _.first(ticketTypes)

          if (ticketType.appliesToSpecificSeats) {
            return _.includes(seat.ticketTypeIds, Number(ticketTypeId))
          }

          return !seat.limitTicketTypes || _.includes(seat.ticketTypeIds, Number(ticketTypeId))
        }).length

        return numSeatsAvailableForTicketType >= numSeatsRequiredForTicketType
      })
  } else {
    const seatsToAssign = unassignedSelectedSeats(order, showing.id, selectedSeats)

    if (_.isEmpty(seatsToAssign)) return false

    return _.some(seatsToAssign, seat => {
      if (ticketTypeOrPackage.appliesToSpecificSeats) {
        return _.includes(seat.ticketTypeIds, ticketTypeOrPackage.id)
      }

      return !seat.limitTicketTypes || _.includes(seat.ticketTypeIds, ticketTypeOrPackage.id)
    })
  }
}
